import apiClient, {
  apiClientForOutSourcing,
} from '../../../utils/lib/apiClient';
import { loadingState, loadingText } from '../../../states/loadingState';
import { useRecoilState, useSetRecoilState } from 'recoil';
import {
  summaryForOutsourcing,
  summaryTotals,
} from '../../../utils/functions/summaryForOutsorcing';
export const useCreateNotePdf = () => {
  const [loadingAnimation, setLoadingAnimation] = useRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);

  const getNotePdf = async (
    summary: summaryForOutsourcing[][],
    summaryTotal: summaryTotals[]
  ) => {
    setLoadingAnimation(true);
    setLoadingText('生成中...');
    try {
      const res = await apiClientForOutSourcing.post(
        `/generate-pdf`,
        {
          summary: summary,
          summaryTotal: summaryTotal,
        },
        {
          responseType: 'blob', // レスポンスをBlobとして受け取る
        }
      );

      const data = res.data;

      return data;
    } catch (e) {
      window.alert(`エラーが発生しました${e}`);
      return null;
    } finally {
      setLoadingAnimation(false);
      setLoadingText('');
    }
  };

  return { getNotePdf, loadingAnimation, loadingText };
};
